import React from 'react';
import type { MultiValueRemoveProps } from 'react-select';
import { components } from 'react-select';

import type { SelectOption } from './types';

// this overrides the default multi select remove icon
const CustomMultiValueRemove = (props: MultiValueRemoveProps<SelectOption, true>) => {
    return (
        <components.MultiValueRemove {...props}>
            <i className="material-symbols-outlined">close</i>
        </components.MultiValueRemove>
    );
};

export default CustomMultiValueRemove;
